/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import Options from './Options/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/PracticeHub/People/Person/Actions"
  
}) {
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 size="normal"
 type="ghost"
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Actions"
/>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 width={10}
/>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<Options
{...childProps}
  viewPath={`${viewPath}/Options`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}